import CmsSelect2 from "../../../../assets/js/modules/cms-select2";
import UserCodeInput from "../../../../assets/js/modules/cms-user-code";
import CmsDatepicker from "../../../../assets/js/modules/cms-datepicker";
import SystemsightFormConditions from "../../../../assets/js/modules/cms-form-conditions";

/**
 * Paraiskos formos papildomi js funcionalumai
 *
 */
class ApplicationsForm {

    static init($form){
        if($form.data('applications-form-instance')){
            return $form.data('applications-form-instance');
        }else{
            let instance = new ApplicationsForm($form)
            $form.data('applications-form-instance', instance);
            return instance
        }
    }

    constructor($form) {
        this.$form = $form;

        this.initFormInputs();
    }

    initFormInputs(){
        CmsSelect2.init(this.$form);
        UserCodeInput.init(this.$form);
        CmsDatepicker.init(this.$form);
        SystemsightFormConditions.init(this.$form);

        this.$form.find("input[data-input_name='aid_receiver']").on('add-subject', function (e, subject) {
            this.fillReceiverData(subject);
        }.bind(this));

        //foreign user type
        this.$form.find('input[name="foreign_code"]').on('add-subject', function (e, subject) {
            this.fillReceiverData(subject);
        }.bind(this))

        this.$form.find("input[data-input_name='related']").on('add-subject', function (e, subject) {
            if(subject.related_users && subject.related_users.length){
                let relatedInputInstance = this.$form.find('input[data-input_name="related"]').data('user_code_instance');
                let releatedIds = [];
                this.$form.find('input[name="related[]"]').each(function (){
                    releatedIds.push(parseInt($(this).val()))
                })
                let aidReceiverId = parseInt(this.$form.find('input[name="aid_receiver"]').val())
                subject.related_users.forEach(function (related) {
                    if(
                        aidReceiverId !== related.id
                        &&
                        releatedIds.indexOf(related.id) === -1
                    ){
                        //pridedam tik tuos, kurie dar nera itraukti
                        relatedInputInstance.addSubject(related, false);
                    }
                });

            }

        }.bind(this));
    }

    fillReceiverData(data){
        if(this.$form.find('input[name="tax_year_match"]').length){
            if(data.reporting_date){
                this.$form.find('input[name="tax_year_match"][value="0"]').prop("checked", true).change();
                let reporting_date = data.reporting_date.split('-');
                this.$form.find('select[name="fin_month"]').val(reporting_date[0]).change();
                this.$form.find('select[name="fin_day"]').val(reporting_date[1]).change();
            }else{
                this.$form.find('input[name="tax_year_match"][value="1"]').prop("checked", true).change();
                this.$form.find('select[name="fin_month"]').val('').change();
                this.$form.find('select[name="fin_day"]').val('').change();
            }
        }

        if(
            this.$form.find('input[data-input_name="related"]').length &&
            //FIXME: ištrinti šį komentarą:
            // Nesuprantu, ar žemiau esantis tikrinimas yra tikrai teisingas, nors lyg ir veikia
            !$("input[type='radio'][name='aid_type'][value='deminimis_aid']").is(':checked'))
        {
            let relatedInputInstance = this.$form.find('input[data-input_name="related"]').data('user_code_instance');
            relatedInputInstance.removeAllSubjects();
            if(data.related_users.length){
                this.$form.find('input[name="has_related_subjects"][value="1"]').prop("checked", true).change();
                data.related_users.forEach(function (related) {
                    relatedInputInstance.addSubject(related, false);
                });
            }
        }
    }

}

export default ApplicationsForm;